import ChildSupport from './ChildSupport';

export default ChildSupport;
